import {
  CheckOutlined,
  QuestionCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import { Col, Row, Tooltip, Select, Input, Button, message } from "antd";
import React, { useState, useEffect } from "react";
import DropdownSelect from "../../../components/generic/DropdownSelect";
import { delimitersList } from "../../../constants/List Constants";
import MapFields from "../../../components/compare/MapFields";
import TaskMapFields from "./TaskMapFields";
import {
  checkFirstRowForEmptyColumn,
  getDelimiter,
  getFirstRow,
} from "../../../helper/file_helper";

const { Option } = Select;
function FileToFileTask(props) {
  const [fileNameOne, setFileNameOne] = useState("");
  const [fileNameTwo, setFileNameTwo] = useState("");
  const [matchTypeOne, setMatchTypeOne] = useState("");
  const [matchTypeTwo, setMatchTypeTwo] = useState("");
  const [matchDisabledOne, setMatchDisabledOne] = useState(false);
  const [matchDisabledTwo, setMatchDisabledTwo] = useState(false);
  const [delimiterOne, setDelimiterOne] = useState("");
  const [delimiterTwo, setDelimiterTwo] = useState("");
  const [fileContentOne, setFileContentOne] = useState("");
  const [fileContentTwo, setFileContentTwo] = useState("");
  const [fileOne, setFileOne] = useState("");
  const [fileTwo, setFileTwo] = useState("");
  const [isGreen, setIsGreen] = useState(false);
  const [fileOneHeader, setFileOneHeader] = useState([]);
  const [fileTwoHeader, setFileTwoHeader] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (props.matchTypeOne === "any" && props.matchTypeTwo === "any") {
      props.updateMatchType("any");
    } else {
      props.updateMatchType("equals");
    }
  }, [matchTypeOne, matchTypeTwo]);

  // Swap the modal body in-place when the mapping editor opens (no nested modal).
  useEffect(() => {
    props.onMapViewChange?.(isOpen);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const getContentOne = (fileObject) => {
    if (fileObject) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setFileContentOne(e.target.result);
      };
      reader.onerror = (e) => {
        console.error("Error reading file:", e.target.error);
      };
      reader.readAsText(fileObject);
    } else {
      console.log("No file selected");
    }
  };
  const getContentTwo = (fileObject) => {
    if (fileObject) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setFileContentTwo(e.target.result);
      };
      reader.onerror = (e) => {
        console.error("Error reading file:", e.target.error);
      };
      reader.readAsText(fileObject);
    } else {
      console.log("No file selected");
    }
  };
  const handleModal = () => {
    setIsOpen(!isOpen);
  };
  const onMappingClick = () => {
    // Clear prerequisites first so an empty parse doesn't surface a confusing
    // delimiter/header error before both files are provided.
    if (!fileOne || !fileContentOne) {
      message.error("Upload the first sample file before you can map fields.");
      return;
    }
    if (!delimiterOne) {
      message.error("Select the delimiter for file 1 before you can map fields.");
      return;
    }
    if (!fileTwo || !fileContentTwo) {
      message.error("Upload the second sample file before you can map fields.");
      return;
    }
    if (!delimiterTwo) {
      message.error("Select the delimiter for file 2 before you can map fields.");
      return;
    }
    let delimOne = getDelimiter(fileContentOne);
    let isOneEmpty = checkFirstRowForEmptyColumn(fileContentOne, delimiterOne);
    let headerOne = [1, 2, 3];
    headerOne = getFirstRow(fileContentOne, delimOne);
    setFileOneHeader(headerOne);
    let delimTwo = getDelimiter(fileContentTwo);
    let isTwoEmpty = checkFirstRowForEmptyColumn(fileContentTwo, delimiterTwo);
    let headerTwo = [1, 2, 3];
    headerTwo = getFirstRow(fileContentTwo, delimTwo);
    setFileTwoHeader(headerTwo);
    if (delimOne !== delimiterOne || isOneEmpty) {
      message.error(
        "Check if the First file delimiter matches the selection or if the header row is empty",
      );
      return;
    }
    if (delimTwo !== delimiterTwo || isTwoEmpty) {
      message.error(
        "Check if the Second file delimiter matches the selection or if the header row is empty",
      );
      return;
    }
    handleModal();
  };
  const mappingConfirmed = (key, tableData, mappingName, fieldTests, type) => {
    const hasData = tableData && tableData.length > 0;
    setIsGreen(hasData);
    props.setMappedData(hasData ? tableData : []);
    props.setMapName(mappingName || "");
    props.setMappingSelection(type === "new" ? "new" : "existing");
    props.saveFileToFileData(
      tableData,
      mappingName,
      matchTypeOne,
      matchTypeTwo,
      fileNameOne,
      fileNameTwo,
      delimiterOne,
      delimiterTwo,
      type,
    );
    setIsOpen(false);
  };

  // Fields are HIDDEN (not unmounted) while the mapping editor is open so the
  // uncontrolled inputs and parsed header state survive the round-trip.
  return (
    <>
      {isOpen && (
        <div className="tm-map-view">
          <button type="button" className="tm-back" onClick={handleModal}>
            <ArrowLeftOutlined /> Back to task
          </button>
          <p className="modal-header-text tm-map-title">Map Fields</p>
          <TaskMapFields
            sqlHeader={fileTwoHeader}
            fileHeader={fileOneHeader}
            clickPrevious={handleModal}
            confirmMapFields={mappingConfirmed}
            mappingSelection={props.mappingSelection}
            setMappingSelection={props.setMappingSelection}
            mapName={props.mapName}
            setMapName={props.setMapName}
            mappedData={props.mappedData}
            setMappedData={props.setMappedData}
            setMappedList={props.setMappedList}
            mappedList={props.mappedList}
          />
        </div>
      )}
    <div style={{ display: isOpen ? "none" : undefined }}>
      <Row>
        <Col span={6}>
          <p className="spec-modal-label">
            Match Filename *{" "}
            <Tooltip title="Enter the name of the file which should match the criteria from dropdown selection">
              <QuestionCircleOutlined
                style={{
                  color: "rgba(0,0,0,.45)",
                }}
              />
            </Tooltip>
          </p>
        </Col>
        <Col span={6}>
          <Select
            placeholder="match type"
            onChange={(e) => {
              if (e === "any") {
                setFileNameOne("");
                setMatchDisabledOne(true);
              } else {
                setMatchDisabledOne(false);
              }
              setMatchTypeOne(e);
              props.setMatchTypeOne(e);
            }}
            style={{ width: "80%" }}
          >
            <Option value="equals">Equals</Option>
            <Option value="contains">Contains</Option>
            <Option value="any">Any</Option>
          </Select>
        </Col>
        <Col span={12}>
          <Input
            value={fileNameOne}
            disabled={matchDisabledOne}
            placeholder="file name"
            onChange={(e) => setFileNameOne(e.target.value)}
            width="100%"
          />
        </Col>
      </Row>
      <Row>
        <Col span={6}>
          <p className="spec-modal-label">
            Delimiter for File 1{" "}
            <Tooltip title="The character separating columns in File 1. Must match the sample file's actual delimiter.">
              <QuestionCircleOutlined style={{ color: "rgba(0,0,0,.45)" }} />
            </Tooltip>
          </p>
        </Col>
        <Col span={18}>
          <DropdownSelect
            placeholder="select delimiter"
            options={delimitersList}
            value={delimiterOne}
            valueKey="value"
            labelKey="label"
            onSelect={(e) => setDelimiterOne(e)}
          />
        </Col>
      </Row>
      <Row>
        <Col span={6}>
          <p className="spec-modal-label">
            Sample with header *{" "}
            <Tooltip title="We will only use the header from the uploaded file for mapping purposes. This is not the Test File">
              <QuestionCircleOutlined
                style={{
                  color: "rgba(0,0,0,.45)",
                }}
              />
            </Tooltip>
          </p>
        </Col>
        <Col span={18}>
          <p>
            <input
              type="file"
              onChange={(e) => {
                getContentOne(e.target.files[0]);
                setFileOne(e.target.files[0]);
              }}
              style={{ color: "black" }}
            />
          </p>
        </Col>
      </Row>

      {/* For File Two*/}
      <Row>
        <Col span={6}>
          <p className="spec-modal-label">
            Match Filename *{" "}
            <Tooltip title="Enter the name of the file which should match the criteria from dropdown selection">
              <QuestionCircleOutlined
                style={{
                  color: "rgba(0,0,0,.45)",
                }}
              />
            </Tooltip>
          </p>
        </Col>
        <Col span={6}>
          <Select
            placeholder="match type"
            onChange={(e) => {
              if (e === "any") {
                setFileNameTwo("");
                setMatchDisabledTwo(true);
              } else {
                setMatchDisabledTwo(false);
              }
              setMatchTypeTwo(e);
              props.setMatchTypeTwo(e);
            }}
            style={{ width: "80%" }}
          >
            <Option value="equals">Equals</Option>
            <Option value="contains">Contains</Option>
            <Option value="any">Any</Option>
          </Select>
        </Col>
        <Col span={12}>
          <Input
            value={fileNameTwo}
            disabled={matchDisabledTwo}
            placeholder="file name"
            onChange={(e) => setFileNameTwo(e.target.value)}
            width="100%"
          />
        </Col>
      </Row>
      <Row>
        <Col span={6}>
          <p className="spec-modal-label">
            Delimiter for File 2{" "}
            <Tooltip title="The character separating columns in File 2. Must match the sample file's actual delimiter.">
              <QuestionCircleOutlined style={{ color: "rgba(0,0,0,.45)" }} />
            </Tooltip>
          </p>
        </Col>
        <Col span={18}>
          <DropdownSelect
            placeholder="select delimiter"
            options={delimitersList}
            value={delimiterTwo}
            valueKey="value"
            labelKey="label"
            onSelect={(e) => setDelimiterTwo(e)}
          />
        </Col>
      </Row>
      <Row>
        <Col span={6}>
          <p className="spec-modal-label">
            Sample with header *{" "}
            <Tooltip title="We will only use the header from the uploaded file for mapping purposes. This is not the Test File">
              <QuestionCircleOutlined
                style={{
                  color: "rgba(0,0,0,.45)",
                }}
              />
            </Tooltip>
          </p>
        </Col>
        <Col span={18}>
          <p>
            <input
              type="file"
              onChange={(e) => {
                getContentTwo(e.target.files[0]);
                setFileTwo(e.target.files[0]);
              }}
              style={{ color: "black" }}
            />
          </p>
        </Col>
      </Row>
      <Row>
        <Col span={6}>
          <p className="spec-modal-label">Mapping Details *</p>
        </Col>
        <Col span={18}>
          <Button
            icon={
              isGreen && (
                <CheckOutlined
                  style={{ color: isGreen ? "green" : "default" }}
                />
              )
            }
            type="dashed"
            onClick={onMappingClick}
            style={{
              borderColor: isGreen ? "green" : "default",
              borderStyle: "dashed",
            }}
          >
            Click here to edit/view mapping
          </Button>
        </Col>
      </Row>
    </div>
    </>
  );
}

export default FileToFileTask;
